import { RouteRecordRaw, RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export const feedbackRouters: RouteRecordRaw[] = [
  {
    path: '/myFeedback',
    name: 'MyFeedback',
    component: () => import('@/pages/h5/Feedback/MyFeedback.vue'),
    meta: { title: '我的反馈' },
  },
  {
    path: '/feedback/:type',
    name: 'Feedback',
    component: () => import('@/pages/h5/Feedback/EditFeedback.vue'),
    meta: {
      title: (routeData: RouteLocationNormalizedLoadedGeneric) => {
        return routeData.params.type === 'reply' ? '回复客服' : '增加反馈';
      },
    },
  },
  {
    path: '/feedback-detail',
    name: 'FeedbackDetail',
    component: () => import('@/pages/h5/Feedback/FeedbackDetail.vue'),
    meta: { title: '反馈详情' },
  },
  // {
  //   path: '/addFeedback',
  //   name: 'AddFeedback',
  //   component: () => import('@/pages/h5/Feedback/AddFeedback.vue'),
  //   meta: { title: '增加反馈' },
  // },
];
